import { faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { issueSeverityEnum } from "kubb";
import React from "react";
import { ErrorBanner } from "../../../components/Error/ErrorBanner.tsx";
import { Button } from "../../../components/Theme/button.tsx";
import {
  Dialog,
  DialogBody,
  DialogTitle,
} from "../../../components/Theme/dialog.tsx";
import DisplayIfUserType from "../../../components/utils/DisplayIfUserType/DisplayIfUserType.tsx";
import { useCreateManualIssue } from "../../../hooks/createEntity.tsx";
import ManualIssueForm, {
  type ManualIssueFormValues,
} from "./ManualIssueForm.tsx";

interface ManualIssueCreateModalProps {
  companyId: string;
  assetPositionId: string;
  onComplete?: () => Promise<any>;
}

export default function ManualIssueCreateModal(
  props: ManualIssueCreateModalProps,
): React.ReactElement {
  const [editing, setEditing] = React.useState(false);

  const create = useCreateManualIssue();

  const submit = async (values: ManualIssueFormValues): Promise<any> => {
    await create.update({
      ...values,
      asset_position_id: props.assetPositionId,
      company_id: props.companyId,
      severity: issueSeverityEnum.ERROR,
      start_date_time: null,
      end_date_time: null,
    });
    setEditing(false);
    return props.onComplete?.();
  };
  return (
    <DisplayIfUserType userTypes={"editor"}>
      <Dialog
        open={editing}
        onClose={() => {
          setEditing(false);
        }}
        data-cy={"create-manual-issue-modal"}
      >
        <DialogTitle>Create Manual Issue</DialogTitle>
        <DialogBody>
          <ManualIssueForm submit={submit} cancel={() => setEditing(false)} />
          <ErrorBanner error={create.error} />
        </DialogBody>
      </Dialog>
      <Button
        onClick={() => setEditing(true)}
        disabled={editing}
        color={"brandLight"}
      >
        <FontAwesomeIcon icon={faPen} className={"px-0 mx-2"} fixedWidth />
        <span>Create Issue</span>
      </Button>
    </DisplayIfUserType>
  );
}
